/**
 * Created by alex.shmaltsuev on 2016-04-12.
 */
import initialState from '../store/initialstate';
import C from '../constants/scoreBoard';

export default (state = initialState().scoreBoard, action = null) => {
    switch (action.type) {
        case C.SCORE_BOARD_TABS:
            Object.keys(action.payload).forEach((tabName) => {
                state =
                    state.updateIn([C.TABS, tabName, C.TAB_CAPTION_KEY],
                                   () => action.payload[tabName][C.TAB_CAPTION_KEY]);

                state =
                    state.updateIn([C.TABS, tabName, C.TAB_NO_DATA_CAPTION_KEY],
                                   () => action.payload[tabName][C.TAB_NO_DATA_CAPTION_KEY]);
                state =
                    state.updateIn([C.TABS, tabName, C.BADGES_CUSTOM_FIELDS],
                        () => action.payload[tabName][C.BADGES_CUSTOM_FIELDS]);
                state =
                    state.updateIn([C.TABS, tabName, C.COLUMNS_CUSTOM_FIELDS],
                        () => action.payload[tabName][C.COLUMNS_CUSTOM_FIELDS]);
                state =
                    state.updateIn([C.TABS, tabName, C.STATIC_FILTER_ID],
                        () => action.payload[tabName][C.STATIC_FILTER_ID]);
                state =
                    state.updateIn([C.TABS, tabName, C.SHOW_ALL_FILTER],
                                       () => action.payload[tabName][C.SHOW_ALL_FILTER]);

            });
            return state;
        case C.SCORE_BOARD_TABS_ORDER:
            return state.set(C.TABS_ORDER, action.payload);
        case C.RECORDS_DISPLAY_IN_LIST:
             return state.set(C.RECORDS_DISPLAY_IN_LIST,action.payload);
        case C.SERVICE_CATALOG_ACTIVE_REQUESTS:
            return state.updateIn([C.TABS, C.MY_REQUEST_TAB, C.ACTIVE_REQUESTS_ARRAY],
                                  () => action.payload);
        case C.SERVICE_CATALOG_ACTIVE_REQUESTS_WIDGET:
            return state.updateIn([C.TABS, C.MY_REQUEST_TAB, C.ACTIVE_REQUESTS_ARRAY_WIDGET],
                                  () => action.payload);
        case  C.SERVICE_CATALOG_CLOSED_REQUESTS:
            return state.updateIn([C.TABS, C.RECENTLY_CLOSED_TAB, C.CLOSED_REQUESTS_ARRAY],
                                  () => action.payload);
        case  C.SERVICE_CATALOG_CLOSED_REQUESTS_WIDGET:
            return state.updateIn([C.TABS, C.RECENTLY_CLOSED_TAB, C.CLOSED_REQUESTS_ARRAY_WIDGET],
                                  () => action.payload);
        case C.SERVICE_CATALOG_SUPERVISED_REQUESTS:
            return state.updateIn([C.TABS, C.SUPERVISED_REQUESTS_TAB, C.SUPERVISED_REQUESTS_ARRAY],
                                  () => action.payload);
        case C.SERVICE_CATALOG_SUPERVISED_REQUESTS_WIDGET:
            return state.updateIn(
                [C.TABS, C.SUPERVISED_REQUESTS_TAB, C.SUPERVISED_REQUESTS_ARRAY_WIDGET],
                () => action.payload);
        case C.SERVICE_CATALOG_PENDING_REQUESTS:
            return state.updateIn([C.TABS, C.PENDING_MY_APPROVAL_TAB, C.PENDING_REQUESTS_ARRAY],
                                  () => action.payload);
        case C.SERVICE_CATALOG_PENDING_REQUESTS_WIDGET:
            return state.updateIn(
                [C.TABS, C.PENDING_MY_APPROVAL_TAB, C.PENDING_REQUESTS_ARRAY_WIDGET],
                () => action.payload);
        case C.SERVICE_CATALOG_ACTIVE_REQUESTS_COUNT:
            return state.updateIn([C.TABS, C.MY_REQUEST_TAB, C.ACTIVE_REQUESTS_COUNT],
                                  () => action.payload.count);
        case C.SERVICE_CATALOG_CLOSED_REQUESTS_COUNT:
            return state.updateIn([C.TABS, C.RECENTLY_CLOSED_TAB, C.CLOSED_REQUESTS_COUNT],
                                  () => action.payload.count);
        case C.SERVICE_CATALOG_SUPERVISED_REQUESTS_COUNT:
            return state.updateIn([C.TABS, C.SUPERVISED_REQUESTS_TAB, C.SUPERVISED_REQUESTS_COUNT],
                                  () => action.payload.count);
        case C.SERVICE_CATALOG_PENDING_REQUESTS_COUNT:
            return state.updateIn([C.TABS, C.PENDING_MY_APPROVAL_TAB, C.PENDING_REQUESTS_COUNT],
                                  () => action.payload.count);
        case C.SCORE_BOARD_ACTIVE_TAB:
            return state.set(C.ACTIVE_TAB_NAME, action.payload);
        case C.SERVICE_CATALOG_RESET_COMP:
            state =
                state.updateIn([C.TABS, C.MY_REQUEST_TAB, C.ACTIVE_REQUESTS_ARRAY],
                               () => action.payload);
            state =
                state.updateIn([C.TABS, C.RECENTLY_CLOSED_TAB, C.CLOSED_REQUESTS_ARRAY],
                               () => action.payload);
            state =
                state.updateIn([C.TABS, C.SUPERVISED_REQUESTS_TAB, C.SUPERVISED_REQUESTS_ARRAY],
                               () => action.payload);
            state =
                state.updateIn([C.TABS, C.PENDING_MY_APPROVAL_TAB, C.PENDING_REQUESTS_ARRAY],
                               () => action.payload);
            return state;
        case C.UPDATE_SHOW_ALL_FILTER:
            state = state.updateIn([C.TABS, state.get(C.ACTIVE_TAB_NAME), C.SHOW_ALL_FILTER],
                                   () => action.payload);
            return state;
            case C.SCORE_BOARD_PAGINATION_CHANGED:
                state = state.updateIn([C.TABS, state.get(C.ACTIVE_TAB_NAME), 'PAGINATION'],
                () => action.payload);
                return state;
        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./reducers/scoreBoard.js